import { get, patch, post } from 'utils/network';
import { ApiRoute } from '../../utils/config';
import { Cart } from '../../models/cart.types';

// Fetch cart & cartItem data for the given cartId
export const fetchCartItems = async (cartId: number): Promise<Cart | undefined> => {
  const {
    ok,
    parsedBody,
  } = await get<Cart>(`${ApiRoute.CARTS}/${cartId}`);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};

// Save cart data for the given cartId
export const saveCart = async (cart: Cart): Promise<Cart | undefined> => {
  const body = {
    id: cart.id,
    priceSummary: cart.priceSummary,
    cartItems: cart.cartItems,
    // uses the cart's shipping address
    shipping_address_id: cart.shippingAddressId,
  };

  const {
    ok,
    parsedBody,
  } = await post<Cart>(`${ApiRoute.CARTS}/${cart.id}?commit=true`, body);
  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};

export const updateCartSkip = async (cartId: number, isSkipped: boolean): Promise<number> => {
  const skipAction = isSkipped ? 'unskip' : 'skip';
  const body = {
    id: cartId,
    skipAction,
  };
  const { ok } = await patch<void>(`${ApiRoute.CARTS}/${cartId}`, body);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return cartId;
};

// Update cart data for the given cartId, and commit the changes to the backend
// (to recalculate pricing and save the cart after a cart change)
// We are adding the param commit=true to implement autosave functionality, while leaving the
// saveCart functionality intact (so users can still manually save when they want to)
export const updatePendingCart = async (cart: Cart): Promise<Cart | undefined> => {
  const body = {
    id: cart.id,
    priceSummary: cart.priceSummary,
    cartItems: cart.cartItems,
  };
  const {
    ok,
    parsedBody,
  } = await post<Cart>(`${ApiRoute.CARTS}/${cart.id}?commit=true`, body);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};

export const fetchPreviewCart = async (): Promise<Cart | undefined> => {
  const {
    ok,
    parsedBody,
  } = await get<Cart>(`${ApiRoute.PREVIEW}`);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};

export const updatePreviewCart = async (cart: Cart): Promise<Cart | undefined> => {
  const body = {
    id: cart.id,
    priceSummary: cart.priceSummary,
    cartItems: cart.cartItems,
  };

  const {
    ok,
    parsedBody,
  } = await post<Cart>(`${ApiRoute.PREVIEW}`, body);

  if (!ok) {
    throw new Error('Network response was not ok');
  }

  return parsedBody;
};
